import { ApiType } from "@gymflow/common";
import { QueryKey } from "@tanstack/react-query";

export const membershipQueryKeys = {
  all: () => ["membership"] as QueryKey,
  list: (filters?: Parameters<ApiType["serviceApi"]["find"]>[0]) =>
    [...membershipQueryKeys.all(), { filters }] as QueryKey,
  summary: (opts?: {
    membershipId: number;
    startDate: string;
    promotionCode?: string;
    userMemberId: string;
  }) => [...membershipQueryKeys.all(), { opts }] as QueryKey,
  details: (membershipId?: number) =>
    [...membershipQueryKeys.all(), membershipId] as QueryKey,
  statusHistory: (memberId?: string) =>
    [...membershipQueryKeys.all(), memberId] as QueryKey,
  calculateCancelDates: (filters?: any) =>
    [membershipQueryKeys.all(), "calculate-cancel-dates", filters] as QueryKey,
};
